<form class="rx-app-flex-container-row" [formGroup]="abutmentSectionForm"
	  [class.read-only]="isReadOnly"
>
	<div class="abutment-section rx-app-flex rx-app-flex-container-row">
		<div class="abutment-section__column">
			<rx-select
				[id]="'abutment-type'"
				[label]="'ToothEditor.AbutmentType' | translate"
				[isDisabled]="isReadOnly"
				[formControl]="abutmentTypeControl"
				[options]="abutmentTypeOptions"
				name="abutmentTypeControl"
			></rx-select>
			<rx-select
				[id]="'abutment-material'"
				[label]="'ToothEditor.AbutmentMaterial' | translate"
				[formControl]="abutmentMaterialControl"
				[options]="abutmentMaterialOptions"
				[isDisabled]="!abutmentTypeControl?.value || isReadOnly"
				name="abutmentMaterialControl"
			></rx-select>
			<rx-select
				[id]="'margin-style'"
				[label]="'ToothEditor.MarginStyle' | translate"
				[formControl]="marginStyleControl"
				[options]="marginStyleOptions"
				[isDisabled]="!abutmentTypeControl?.value || isReadOnly"
				name="marginStyleControl"
			></rx-select>
		</div>
	</div>
</form>
